import * as actionTypes from "../../../constants/ActionTypes/AdminPortal/FeatureSwitch";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null
}

const FeatureSwitchCountry = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_INIT:
            return {
                ...state,
                loading: true,
                success: false
            }
        
        case actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true
            }
        
        case actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {}
            }
        case actionTypes.FEATURE_SWITCH_RESET_STATE:
            return {
                data: {},
                loading: false,
                success: false,
                error: null
            }
        default:
            return {...state}
    }
}

export default FeatureSwitchCountry